import styled from 'styled-components/macro';
import { space, SpaceProps } from 'styled-system';
import css from '@styled-system/css';
import { themeGet } from '@styled-system/theme-get';

export const StyledFullHeightCont = styled.div`
  display: flex;
  align-items: center;
  min-height: 100vh;
  width: 100%;
`;

export const StyledWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  width: min(456px, 100vw - 40px);
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ShortContainer = styled.div((props) =>
  css({
    margin: '0 auto',
    width: '100%',
    p: '0 20px',
    maxWidth: props.theme.sizes[0]
  })
);

export const Container = styled.div((props) =>
  css({
    margin: '0 auto',
    width: '100%',
    p: '0 20px',
    maxWidth: props.theme.sizes[1]
  })
);

export const Row = styled.div<SpaceProps>`
  ${space};
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const StyledHeading = styled.h5`
  margin-bottom: 28px;
  text-align: center;
  font-size: 20px;
  font-weight: ${themeGet('fontWeights.semi')};
  color: ${themeGet('colors.body.text')};
`;
